/**
 * Deep link to a debt's pre-Forest history.
 *
 * The payment page's main tab is component state with no route of its own, so the link
 * carries the panel to open. `tab` is already taken by the pay-in-full / partial / plan
 * selector, hence `panel`.
 */
const PANEL_PARAM = 'panel';
const OPEN_PARAM = 'history';

/**
 * Preview and demo mode are not threaded through: both persist in `sessionStorage`, so
 * they survive this navigation without the flag being restated on the URL.
 */
export function migratedHistoryPath(debtId: string): string {
  const params = new URLSearchParams({ [PANEL_PARAM]: 'transactions', [OPEN_PARAM]: 'open' });
  return `/payment/${debtId}?${params}`;
}

/** True when the link asked for the transactions panel. */
export function wantsTransactionsPanel(search: string): boolean {
  return new URLSearchParams(search).get(PANEL_PARAM) === 'transactions';
}

/** True when the link asked for the history card to arrive already open. */
export function wantsHistoryOpen(search: string): boolean {
  return new URLSearchParams(search).get(OPEN_PARAM) === 'open';
}

/** The same params, minus the deep link, so consuming it cannot leave a stale request behind. */
export function stripHistoryLink(params: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(params);
  next.delete(PANEL_PARAM);
  next.delete(OPEN_PARAM);
  return next;
}
